'use client';

export function ThinkingRow() {
	return (
		<div className="ai-msg-enter mb-8 flex items-center gap-1.5 py-2">
			{[0, 1, 2].map((i) => (
				<span
					key={i}
					className="ai-typing-dot inline-block size-1.5 rounded-full bg-gray-3"
					style={{ animationDelay: `${i * 160}ms` }}
				/>
			))}
		</div>
	);
}
